import { SkeletonBox } from '@/components';
import { Box } from '@palmetto/palmetto-components';
import React from 'react';

export const ProjectTransactionsLoading: React.FC<{ rows?: number }> = ({ rows = 15 }) => {
  return (
    <Box direction="column" gap="sm">
      {Array.from({ length: rows }).map((_, index) => (
        <Box key={index} direction="row" gap="md" alignItems="center">
          <SkeletonBox width="20%" height="40px" />
          <SkeletonBox width="30%" height="40px" />
          <SkeletonBox width="15%" height="40px" />
          <SkeletonBox width="25%" height="40px" />
          <SkeletonBox width="10%" height="40px" />
        </Box>
      ))}
    </Box>
  );
};
